import resolveEstadoSolicitudVariant from '@/shared/estados/estados.solicitud.util';
import { EstadoSolicitud } from '@/shared/model/enumerations/estado-solicitud.model';
import { TipoCartaConclusion } from '../enumerations/tipo-carta-conclusion.model';

export interface IEventoCartaConclusion {
  estado?: EstadoSolicitud | null;
  cvu?: number | null;
  usuario?: string | null;
  nombreCompletoUsuario?: string | null;
  observacion?: string | null;
  fecha?: string | null;
  activo?: boolean | null;
  estadoTexto?: string | null;
  variant?: string | null;
}

export class EventoCartaConclusion implements IEventoCartaConclusion {
  constructor(
    public estado?: EstadoSolicitud | null,
    public cvu?: number | null,
    public usuario?: string | null,
    public nombreCompletoUsuario?: string | null,
    public observacion?: string | null,
    public fecha?: string | null,
    public activo?: boolean | null,
    public estadoTexto?: string | null,
    public variant?: string | null
  ) {}

  static fromObject(data: IEventoCartaConclusion): EventoCartaConclusion {
    const eventoCartaConclusion = new EventoCartaConclusion();
    for (const [key, value] of Object.entries(data)) {
      eventoCartaConclusion[key] = value;
    }

    eventoCartaConclusion.variant = resolveEstadoSolicitudVariant(eventoCartaConclusion?.estado);

    return eventoCartaConclusion;
  }
}
export interface IEventosMasivosCartaConclusion {
  tipo?: TipoCartaConclusion;
  estadoActual?: EstadoSolicitud;
  nuevoEstado?: EstadoSolicitud;
  observacionEvento?: string;
}

export class EventosMasivosCartaConclusion implements IEventosMasivosCartaConclusion {
  constructor(
    public tipo?: TipoCartaConclusion,
    public estadoActual?: EstadoSolicitud,
    public nuevoEstado?: EstadoSolicitud,
    public observacionEvento?: string
  ) {}
}
